import { WorkloadSettings } from '@idmc-ms-fabric/integration';
import React from 'react';

import { initializeAgentService } from '../services/agent-service';
import { initializeSearchService } from '../services/ccgf-searchv2';
import { initializeFabricBEService } from '../services/fabric-be-service';
import { initializeFrsService } from '../services/frs-service';
import { initializeCloudShellService, initializeIdentityService, initializeLicenseService, initializeSessionService } from '../services/iics-service';
import { initializeSAASService } from '../services/saas-service';
import { initializeScheduleService } from '../services/schedule';

interface IServicesContextProps {
	fetchApi: typeof window.fetch;
	serviceBaseURLs: Record<string, string>;
	tenantId: string;
	extensionSettings?: WorkloadSettings;
}

const initialize = (fetchApi: typeof window.fetch, serviceBaseURLs: Record<string, string>, tenantId: string, extensionSettings?: WorkloadSettings) => ({
	fetchApi,
	serviceBaseURLs,
	tenantId,
	search: initializeSearchService({ fetchApi, serviceBaseURLs, tenantId }),
	schedule: initializeScheduleService({ fetchApi, serviceBaseURLs, tenantId }),
	saas: initializeSAASService({ fetchApi, serviceBaseURLs, tenantId }),
	frsService: initializeFrsService({
		fetchApi,
		serviceBaseURLs,
		tenantId,
	}),
	fabricBeService: initializeFabricBEService({
		fetchApi,
	}),
	agentService: initializeAgentService({ fetchApi, serviceBaseURLs, tenantId }),
	identityService: initializeIdentityService({ fetchApi, serviceBaseURLs, tenantId }),
	cloudShellService: initializeCloudShellService({ fetchApi, serviceBaseURLs, tenantId }),
	sessionService: initializeSessionService({ fetchApi, serviceBaseURLs, tenantId }),
	licenseService: initializeLicenseService({ fetchApi, serviceBaseURLs, tenantId }),
	extensionSettings,
});

let registryInstance: ReturnType<typeof initialize>;

export const ServiceRegistry = {
	get: () => registryInstance,
};

export const initializeRegistry = async ({ fetchApi, serviceBaseURLs, tenantId, extensionSettings }: IServicesContextProps) => {
	registryInstance = initialize(fetchApi, serviceBaseURLs, tenantId, extensionSettings);

	if (process.env.NODE_ENV === 'development') {
		Object.assign(window, { serviceRegistryInstance: registryInstance });
	}
};

export const ServiceRegistryContext: React.FC<IServicesContextProps> = ({ fetchApi, serviceBaseURLs, tenantId, children, extensionSettings }) => {
	if (!registryInstance) {
		throw initializeRegistry({
			fetchApi,
			serviceBaseURLs,
			tenantId,
			extensionSettings,
		});
	}

	return <>{children}</>;
};
